import CommercialIcon from '../../../../assets/icon_commercial.svg';
import ResidentialIcon from '../../../../assets/icon_residential.svg';
import messages from './messages';

export const getDescriptionItemValues = (isResidential: boolean, isFreeApartment: boolean) => {
  if (isResidential) {
    return {
      description: isFreeApartment
        ? messages.CreateSiteModalSiteTypeResidentialInfoBoxTextVer2
        : messages.selectSiteTypeModalSiteTypeResidentialInfoBoxText,
      icon: ResidentialIcon,
      title: messages.CreateSiteModalSiteTypeResidentialInfoBoxTitle,
    };
  } else {
    return {
      description: messages.CreateSiteModalSiteTypeCommercialInfoBoxText,
      icon: CommercialIcon,
      title: messages.CreateSiteModalSiteTypeCommercialInfoBoxTitle,
    };
  }
};
